import {
  HttpErrorResponse,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { SessionService } from '@sh/services/auth/session.service';
import { catchError, throwError } from 'rxjs';

/**
 * Treats any 401 on an authenticated request as "logged out": ends the session
 * and routes to landing. This covers the post-deletion window where the old ID
 * token is still cryptographically valid but the server can no longer resolve
 * the user, plus the "app open in another tab" edge case.
 *
 * SessionService is resolved lazily to avoid a construction-time DI cycle
 * (SessionService -> ProfileService -> HttpClient -> interceptors).
 */
@Injectable()
export class AuthErrorInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      catchError((error: unknown) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          this.injector.get(SessionService).endSession();
        }
        return throwError(() => error);
      }),
    );
  }
}
